import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  container: {
    position: 'relative'
  },
  actionBar: {
    marginBottom: '32px',
    display: 'flex',
    '& .modal-trigger': {
      marginRight: '10px'
    }
  },
  status: {
    marginRight: '10px'
  },
  membersTable: {
    '& .MuiTableCell-head': {
      lineHeight: '36px'
    }
  },
  roleCell: {
    minWidth: '180px'
  },
  portalCell: {
    minWidth: '80px'
  }
}));
export default useStyles;